import type { MioLiveContext } from '@mio/shared';

const PROGRAMME_STARTERS = [
  "What's next for me?",
  'Where am I in the programme?',
  'What is this module about?',
];

function shortTitle(title: string): string {
  const trimmed = title.trim().replace(/\s+/g, ' ');
  return trimmed.length > 60 ? `${trimmed.slice(0, 57).trimEnd()}…` : trimmed;
}

/**
 * Opening prompts that name what the learner is looking at, so the first question is one tap
 * away. Purely derived from the observed page; nothing here is sent until the learner chooses.
 */
export function mioSuggestions(context: MioLiveContext | null): string[] {
  if (!context) return PROGRAMME_STARTERS;
  if (context.environment === 'workshop')
    return [
      'What does this milestone ask me to do?',
      'Explain what my open file does',
      "I'm stuck. Where should I look first?",
    ];
  const section = context.sectionTitle?.trim();
  if (context.activity && section)
    return [
      `Explain "${shortTitle(section)}" in plain words`,
      'Show me a diagram of this idea',
      'Give me a worked example',
    ];
  if (context.activity)
    return [
      `What is the key idea of "${shortTitle(context.activity.title)}"?`,
      'Show me a diagram of this lesson',
      'Give me a worked example',
    ];
  return [
    PROGRAMME_STARTERS[0] ?? '',
    PROGRAMME_STARTERS[1] ?? '',
    context.module
      ? `What is Module ${context.module.number} about?`
      : (PROGRAMME_STARTERS[2] ?? ''),
  ];
}
